import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { Printer } from "~/providers/printing-provider";

interface PrinterStoreState {
  systemPrinters: Electron.PrinterInfo[];
  setSystemPrinters: (printers: Electron.PrinterInfo[]) => void;
  selectedPrinter?: Printer;
  setSelectedPrinter: (printer?: Printer) => void;
  printerDialogOpen: boolean;
  setPrinterDialogOpen: (open: boolean) => void;
}

export const usePrinterStore = create<PrinterStoreState>()(
  devtools((set) => ({
    systemPrinters: [],
    setSystemPrinters: (printers) => {
      set(() => ({ systemPrinters: printers }));
    },
    printerDialogOpen: false,
    setPrinterDialogOpen: (open) => {
      set(() => ({ printerDialogOpen: open }));
    },
    setSelectedPrinter: (printer) => {
      set(() => ({ selectedPrinter: printer }));
    },
  })),
);
